/**
 * @returns true if price is 0.
 */
export const isFreePlan = plan => {
  var _plan$pricing;
  return ((_plan$pricing = plan.pricing) == null || (_plan$pricing = _plan$pricing.price) == null ? void 0 : _plan$pricing.value) === '0';
};
//# sourceMappingURL=is-free-plan.js.map